const defaultAttributes = ['POSITION', 'TEXCOORD'];
const defaultUniforms = ['MATRIX_MVP', 'MainTex', 'MainTex_ST'];
var ShaderType;
(function (ShaderType) {
    ShaderType[ShaderType["VERTEX"] = 0] = "VERTEX";
    ShaderType[ShaderType["FRAGMENT"] = 1] = "FRAGMENT";
})(ShaderType || (ShaderType = {}));
export class Shader {
    static sharedShaders = {};
    _name;
    _gl;
    _program;
    _uniforms = {};
    _attributes = {};
    constructor(gl, name) {
        this._name = name;
        this._gl = gl;
    }
    get name() {
        return this._name;
    }
    static dispose() {
        this.sharedShaders = {};
    }
    static _createProgram(gl, vertexShader, fragmentShader) {
        const program = gl.createProgram();
        if (!program) {
            throw new Error('Failed to create Program');
        }
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            throw new Error(gl.getProgramInfoLog(program) || '');
        }
        return program;
    }
    static _createShader(gl, type, src) {
        const shader = gl.createShader(type === ShaderType.VERTEX ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER);
        if (!shader) {
            throw new Error('Failed to create Shader');
        }
        gl.shaderSource(shader, src);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            throw new Error(gl.getShaderInfoLog(shader) || '');
        }
        return shader;
    }
    compile(vert, frag) {
        const gl = this._gl;
        const vertShader = Shader._createShader(gl, ShaderType.VERTEX, vert);
        const fragShader = Shader._createShader(gl, ShaderType.FRAGMENT, frag);
        this._program = Shader._createProgram(gl, vertShader, fragShader);
        defaultAttributes.forEach(key => {
            this.getAttribute(key);
        });
        defaultUniforms.forEach(key => {
            this.getUniform(key);
        });
    }
    activate() {
        this._gl.useProgram(this._program);
    }
    deactivate() {
        this._gl.useProgram(null);
    }
    getUniform(key) {
        if (!(key in this._uniforms)) {
            const gl = this._gl;
            const location = gl.getUniformLocation(this._program, key);
            if (location !== null) {
                this._uniforms[key] = location;
            }
        }
        return this._uniforms[key];
    }
    getAttribute(key) {
        if (!(key in this._attributes)) {
            const gl = this._gl;
            this._attributes[key] = gl.getAttribLocation(this._program, key);
        }
        return this._attributes[key];
    }
}
//# sourceMappingURL=Shader.js.map